import 'core-js/actual/object/has-own'
import { EffectFade, Grid, Navigation, Thumbs } from 'swiper'
import type { SwiperProps } from 'swiper/react'
import { SwiperStyle } from './ThumbSlider.styles'
import type { ThumbSliderProps } from './ThumbSlider.types'

export const ThumbSlider = ({
  className,
  onSliderInit,
  hasBullets,
  bulletsType,
  hasModel,
  children,
}: ThumbSliderProps): JSX.Element => {
  const slidesPerView = hasModel ? 5 : 4
  const sliderSettings: SwiperProps = {
    ...(hasBullets && { spaceBetween: 20 }),
    ...(bulletsType === 'squared' && { spaceBetween: 4 }),
    modules: [Navigation, Thumbs, EffectFade, Grid],
    onSwiper: onSliderInit,
    watchSlidesProgress: true,
    slidesPerView:
      hasBullets && Object.hasOwn(children, 'length')
        ? children.length
        : slidesPerView,
    grid: {
      fill: 'row',
      rows: hasBullets ? 1 : 2,
    },
    allowTouchMove: false,
    breakpoints: {
      1366: {
        slidesPerView: children.length,
        grid: {
          rows: 1,
          fill: 'row',
        },
      },
    },
  }

  return (
    <SwiperStyle className={className} {...sliderSettings}>
      <>{children}</>
    </SwiperStyle>
  )
}
